import { Col, Form, Row } from "react-bootstrap";
import TableFilterBox from "../organisms/TableFilterBox";
import TableHeader from "../organisms/TableHeader";
import TableFooter from "../organisms/TableFooter";
import styled from "styled-components";
import DataTable from "./DataTable";
import { Link, useLocation } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import TablePagination from "../molecules/TablePagination";
import axios from "axios";
import { useSelector } from "react-redux";
import SelectBox from "../molecules/SelectBox";

const TableWrap = styled.div`
    flex: 1 1;
    display: flex;
    flex-direction: column;

    .data-table {
        flex-grow: 1;
    }
`;

export default function BranchManagement() {
    const location = useLocation();
    const perPageOptions = useSelector(state => state.perPageOptions);
    const areaOptions = useSelector(state => state.areaOptions).options;
    const loginInfo = useSelector(state => state.login);

    const defaultFilter = {
        orderField: "register_time",
        order: "desc",
        page: 1,
        perPage: perPageOptions[0].value,
        region: "",
        searchName: "",
    }
    const filterSearchNameRef = useRef();

    const [tableData, setTableData] = useState({
        orderField: ["region", "company", "branch", "owner", "tel", "registerTime"],
        head: ["지역", "업체명", "지점명", "대표자명", "전화번호", "등록일시"],
        body: [],
    });
    const [filterRegion, setFilterRegion] = useState(localStorage.getItem("digilog_bFilter") ? JSON.parse(localStorage.getItem("digilog_bFilter")).region : defaultFilter.region);
    const [filter, setFilter] = useState(localStorage.getItem("digilog_bFilter") ? JSON.parse(localStorage.getItem("digilog_bFilter")) : defaultFilter);
    const [dataTotal, setDataTotal] = useState(0);

    const {isError, isLoading, refetch, isRefetching} = useQuery({
        queryKey: ['branchList'],
        queryFn: () => {
            return axios("/branch/list", {
                method: "POST",
                data: {
                    ...filter,
                    region: filterRegion
                }
            }).then((result) => {
                if (result.status == "200") {
                    const arr = [];
                    if (result.data.data.list.length > 0) {
                        result.data.data.list.forEach((el, idx) => {
                            arr.push(
                                [
                                    el.region,
                                    el.companyName,
                                    <Link to={"/admin/detail/branch/" + el.branchId} onClick={() => {
                                        localStorage.setItem("digilog_bFilter", JSON.stringify(filter));
                                    }}>{el.branchName}</Link>,
                                    el.owner,
                                    el.tel,
                                    el.registerTime,
                                ]
                            );
        
                            setTableData({
                                ...tableData,
                                total: result.data.data.total,
                                body: arr
                            });
                        });
                    } else {
                        setTableData({
                            ...tableData,
                            body: []
                        });
                    }

                    setDataTotal(result.data.data.total);
                } else {
                    setDataTotal(0);
                    throw new Error(result);
                }

                return result.data;
            })
        },
        enabled: false,
    });

    useEffect(() => {
        refetch();
    },[filter]);

    useEffect(() => {
        refetch();
    },[location])

    useEffect(() => {
        localStorage.removeItem("digilog_bFilter");
    },[]);

    return (
        <>
            <TableFilterBox 
                // 검색
                handleClickSubmit={() => {
                    setFilter({
                        ...filter,
                        page: 1,
                        region: filterRegion,
                        searchName: filterSearchNameRef.current.value
                    });
                }}
                handleClickReset={() => {
                    setFilterRegion("");
                    filterSearchNameRef.current.value = "";
                    setFilter({
                        ...filter,
                        ...defaultFilter,
                    });
                }}
            >
                <Row className="justify-content-between">
                    <Col sm={6} xxl={5}>
                        <Form.Group as={Row}>
                            <Form.Label column sm={2} xxl={3}>
                                지역
                            </Form.Label>
                            <Col sm={10} xxl={9}>
                                <SelectBox onChange={(value) => {
                                    setFilterRegion(value.value);
                                }} 
                                data={[
                                    {
                                        label: "전체",
                                        value: ""
                                    },
                                    ...areaOptions
                                ]}
                                placeholder="전체"
                                value={filterRegion}
                                >

                                </SelectBox>
                            </Col>
                        </Form.Group>
                    </Col>

                    <Col sm={6} xxl={5}>
                        <Form.Group as={Row}>
                            <Form.Label column sm={2} xxl={3}>
                                업체/지점명
                            </Form.Label>
                            <Col sm={10} xxl={9}>
                                <Form.Control ref={filterSearchNameRef} type="text" defaultValue={filter.searchName} placeholder="업체명 또는 지점명을 입력하세요." />
                            </Col>
                        </Form.Group>
                    </Col>
                </Row>
            </TableFilterBox>

            <TableWrap className="mt-4">

                <TableHeader total={dataTotal}>

                    <div style={{width: "200px"}}>
                        <SelectBox
                            onChange={(value) => {
                                setFilter({
                                    ...filter,
                                    perPage: value.value
                                });
                            }} 
                            className="w-auto"
                            defaultValue={filter.perPage}
                            data={perPageOptions}
                        />
                    </div>                    

                    {
                        loginInfo.admin.level < 3 &&
                        <TableHeader.ButtonBox>
                            <Link to="/admin/add/branch" className="btn btn-primary">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"/>
                                </svg>
                                지점 등록
                            </Link>
                        </TableHeader.ButtonBox>
                    }
                </TableHeader>
                <DataTable data={tableData} sort={[5]} activeSortIdx={5} isError={isError} 
                    useNo={true}
                    isLoading={isLoading || isRefetching}
                    handleClickSort={(idx, type) => {
                        setFilter({
                            ...filter,
                            orderField: tableData.orderField[idx],
                            order: type,
                        })
                    }} 
                />

                <TableFooter>
                    <TablePagination onChange={(value) => {
                        setFilter({
                            ...filter,
                            page: value
                        })
                    }} total={dataTotal} perPage={filter.perPage} currentPage={filter.page}/>
                </TableFooter>
            </TableWrap>
        </>
    );
}
